/**
 * Utility function to apply theme variables to the DOM
 * @param {Object} themeData - The theme data object containing colors, typography, etc.
 */
export const applyThemeVariables = (themeData) => {
  if (!themeData) {
    console.warn('No theme data provided to applyThemeVariables');
    return;
  }

  const root = document.documentElement;
  
  // Aplica cores
  if (themeData.colors) {
    Object.entries(themeData.colors).forEach(([key, values]) => {
      Object.entries(values).forEach(([shade, color]) => {
        root.style.setProperty(`--color-${key}-${shade}`, color);
      });
    });
  }

  // Aplica famílias de fonte de forma dinâmica
  if (themeData.typography?.fontFamily) {
    Object.entries(themeData.typography.fontFamily).forEach(([family, value]) => {
      root.style.setProperty(`--font-${family}`, value);
    });
  }

  // Aplica tamanhos de fonte de forma dinâmica
  if (themeData.typography?.fontSize) {
    Object.entries(themeData.typography.fontSize).forEach(([size, value]) => {
      root.style.setProperty(`--font-size-${size}`, value);
    });
  }

  // Aplica borderRadius
  if (themeData.borderRadius) {
    Object.entries(themeData.borderRadius).forEach(([key, value]) => {
      root.style.setProperty(`--border-radius-${key}`, value);
    });
  }

  // Aplica spacing
  if (themeData.spacing) {
    Object.entries(themeData.spacing).forEach(([key, value]) => {
      root.style.setProperty(`--spacing-${key}`, value);
    });
  }

  // Aplica componentes
  if (themeData.components) {
    Object.entries(themeData.components).forEach(([component, variants]) => {
      Object.entries(variants).forEach(([variant, styles]) => {
        Object.entries(styles).forEach(([property, value]) => {
          root.style.setProperty(
            `--${component}-${variant}-${property}`,
            value
          );
        });
      });
    });
  }
};

